const MinusIcon = () => (
    <svg
        width='17'
        height='17'
        viewBox='0 0 17 17'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M5 8.99951H13'
            stroke='#363853'
            strokeWidth='1.5'
            strokeLinecap='round'
        />
    </svg>
)

export default MinusIcon
